import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { businessAdminRouter } from './routing/businessAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { NoPermissionRequired } from './access-control/businessAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'business',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'business-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES },
  routers: {
    admin: [businessAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.Business,
      attachToV2: AdminNavEntryPointV2.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-business-program-list',
          labelId: 'businessDomain.businessPrograms.title',
          accessControl: NoPermissionRequired,
          positionNavV2: 3,
        },
      ],
    },
  ],
}

export default definition
